import React from "react";
import { ModeRendererProps } from "./types";

export function TinguelyMode({ brand }: ModeRendererProps) {
  return (
    <g>
      <rect x="0" y="0" width="794" height="1123" fill="url(#metal)" />
      
      {/* Random interconnected gears */}
      <g opacity="0.9">
        {[
          [150, 200, 1, 0],
          [280, 250, 0.8, 45],
          [420, 180, 1.2, 90],
          [180, 400, 0.9, 120],
          [350, 450, 1.1, 180],
          [550, 380, 0.85, 240],
          [250, 600, 1, 300],
          [480, 650, 0.95, 30],
          [620, 550, 1.15, 150],
          [150, 800, 0.9, 210],
          [400, 850, 1, 270],
          [600, 900, 0.8, 330],
        ].map(([x, y, scale, rotation], i) => (
          <g key={i} transform={`translate(${x} ${y}) scale(${scale}) rotate(${rotation})`}>
            <use href={i % 2 === 0 ? "#gear" : "#gearLarge"} />
            {i % 3 === 0 && <use href="#wheel" transform="translate(60 0) scale(0.6)" />}
          </g>
        ))}
      </g>
      
      {/* Connecting rods */}
      {[
        [150, 200, 280, 250],
        [280, 250, 420, 180],
        [180, 400, 350, 450],
        [350, 450, 550, 380],
        [250, 600, 480, 650],
        [480, 650, 620, 550],
        [150, 800, 400, 850],
        [400, 850, 600, 900],
      ].map(([x1, y1, x2, y2], i) => (
        <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke={brand.white} strokeWidth="2" strokeDasharray="4 4" opacity="0.4" />
      ))}
      
      {/* Signature scribbles */}
      {Array.from({ length: 15 }).map((_, i) => (
        <path
          key={i}
          d={`M${50 + i * 50} ${950 + (i % 4) * 15} q ${10 + (i % 3) * 5} -20 20 0 t 15 0`}
          stroke={i % 2 ? brand.aqua : brand.amber}
          strokeWidth="1.5"
          fill="none"
          opacity="0.6"
        />
      ))}
    </g>
  );
}
